import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const SidebarWrapper = styled.div`
  background: #fff;
  box-shadow: 4px 0 16px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  left: 0;
  height: 100%;
  max-height: calc(100vh - 90px);
  overflow-y: auto;
  padding: 30px 40px;
  position: absolute;
  width: 386px;
  z-index: 4;

  a:hover {
    text-decoration: none;
  }

  #header-title {
    color: #1277c6;
    font-size: 27px;
    font-weight: 500;
    line-height: 1.1;
    letter-spacing: -0.57px;
    margin: 0;

    @media (max-width: 970px) {
      font-size: 19px;
    }
    @media (max-width: 320px) {
      font-size: 16px;
    }
  }

  .disclaimer {
    color: ${Colors.accent.grey1.standard};
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;

    @media only screen and (-ms-high-contrast: active),
      (-ms-high-contrast: none) {
      display: block;
    }
  }

  @media not all and (min-resolution: 0.001dpcm) {
    /* Safari 10.1+ */
    overflow-y: visible;
  }
  @media (max-width: 970px) {
    bottom: 0;
    height: auto;
    padding: ${(props) =>
      props.isIosSafari ? '20px 20px 130px 20px' : '20px'};
    left: 0;
    right: 0;
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 580px;
  padding-bottom: 15px;
  width: 100%;

  @media (max-width: 970px) {
    align-items: center;
    height: 44px;
    justify-content: center;
    padding: 10px 0 25px 0;
  }
`;

export const NavPrevMobile = styled.a`
  background: url('/public-assets/images/interactive-floorplan/left-caret.svg')
    center center no-repeat;
  background-size: auto 22px;
  display: none;
  height: 44px;
  margin-right: auto;
  overflow: hidden;
  text-indent: -1000em;
  width: 44px;

  @media (max-width: 970px) {
    display: block;
  }
`;

export const NavNextMobile = styled(NavPrevMobile)`
  background-image: url('/public-assets/images/interactive-floorplan/right-caret.svg');
  margin-left: auto;
  margin-right: 0;
`;

export const FooterDesktop = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;

  @media (max-width: 970px) {
    display: none;
  }
`;

export const NavControls = styled.div`
  margin-top: auto;
  transition: all 600ms ease-out;

  @media only screen and (-ms-high-contrast: active),
    (-ms-high-contrast: none) {
    height: 45px;
    margin-top: 65px;

    span {
      height: 40px;
      margin: 0 2.5px;
      width: 40px;
    }
  }
  @media (max-width: 970px) {
    display: none;
  }
`;

export const NavNext = styled.span`
  background-image: url('/public-assets/images/interactive-floorplan/right-btn.svg');
  background-size: 100% 100%;
  cursor: pointer;
  border: none;
  display: block;
  float: left;
  height: 38px;
  opacity: 0.7;
  overflow: hidden;
  text-indent: -1000em;
  transition: all 300ms ease-out;
  width: 38px;

  :hover {
    opacity: 1;
  }
`;

export const NavPrev = styled(NavNext)`
  background-image: url('/public-assets/images/interactive-floorplan/left-btn.svg');
  margin-right: 10px;
`;

export const CtaLabel = styled.span`
  color: #7f7f7f;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
  margin-top: 20px;

  @media only screen and (-ms-high-contrast: active),
    (-ms-high-contrast: none) {
    display: block;
  }
  @media (max-width: 970px) {
    display: none;
  }
`;
